(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-meta-tags.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-meta-tags.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation,
  matchPath = _ReactRouterDOM.matchPath;
const _React = React,
  useCallback = _React.useCallback;
setGlobal('svs.eInstant.shared.hooks.useMetaTags', function () {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    ticketInfo = _ref.ticketInfo,
    category = _ref.category;
  const _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  const updateSeoTags = useCallback(function () {
    let manualPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let seoTitle = svs.eInstant.data.defaultModuleTitle;
    let seoDescription = '';
    let seoKeywords = '';
    if (ticketInfo) {
      seoTitle = ticketInfo.seoTitle || ticketInfo.name;
      seoDescription = ticketInfo.seoDescription || ticketInfo.name;
      seoKeywords = ticketInfo.seoKeywords || ticketInfo.name;
    }
    if (category) {
      seoTitle = category.metaTitle || category.title;
      seoDescription = category.metaDescription || category.title;
      seoKeywords = category.metaKeywords || category.title;
    }
    for (const route of Object.keys(svs.core.data.routesMetaData)) {
      if (matchPath(manualPath || pathname, {
        path: route,
        exact: true
      })) {
        var _routeMatch$title, _routeMatch$metaDescr, _routeMatch$metaKeywo;
        const routeMatch = svs.core.data.routesMetaData[route];
        const newTitle = (routeMatch === null || routeMatch === void 0 || (_routeMatch$title = routeMatch.title) === null || _routeMatch$title === void 0 ? void 0 : _routeMatch$title.replace(/{{metaTitle}}/g, seoTitle)) || seoTitle;
        document.title = newTitle;
        svs.eInstant.logger.debug("Setting page title to: ".concat(newTitle));
        const newSeoDescription = (routeMatch === null || routeMatch === void 0 || (_routeMatch$metaDescr = routeMatch.metaDescription) === null || _routeMatch$metaDescr === void 0 ? void 0 : _routeMatch$metaDescr.replace(/{{metaDescription}}/g, seoDescription)) || seoDescription;
        const newSeoKeywords = (routeMatch === null || routeMatch === void 0 || (_routeMatch$metaKeywo = routeMatch.metaKeywords) === null || _routeMatch$metaKeywo === void 0 ? void 0 : _routeMatch$metaKeywo.replace(/{{metaKeywords}}/g, seoKeywords)) || seoKeywords;
        svs.eInstant.util.setMetaTags(newTitle, newSeoDescription, newSeoKeywords);
        return;
      }
    }

    document.title = svs.eInstant.data.defaultModuleTitle;
    const _svs$eInstant$data$de = svs.eInstant.data.defaultSeo,
      _svs$eInstant$data$de2 = _svs$eInstant$data$de.title,
      title = _svs$eInstant$data$de2 === void 0 ? svs.eInstant.data.defaultModuleTitle : _svs$eInstant$data$de2,
      _svs$eInstant$data$de3 = _svs$eInstant$data$de.metaDescription,
      metaDescription = _svs$eInstant$data$de3 === void 0 ? '' : _svs$eInstant$data$de3,
      _svs$eInstant$data$de4 = _svs$eInstant$data$de.metaKeywords,
      metaKeywords = _svs$eInstant$data$de4 === void 0 ? '' : _svs$eInstant$data$de4;
    svs.eInstant.util.setMetaTags(title, metaDescription, metaKeywords);
  }, [pathname, ticketInfo]);
  return {
    update: manualPath => {
      updateSeoTags(manualPath);
    }
  };
});

 })(window);